import React, {useState, useEffect} from 'react';
import {Container, Grid, Icon, Paper, Typography} from "@mui/material";
import {lightBlue} from "@mui/material/colors";
import PrimaryButton from "../../Common/PrimaryButton";
import {differenceInHours, format, parse} from "date-fns";
import {useHistory} from 'react-router-dom';
import {getDayTripFormattedDate, getTripFormattedDate} from '../../../utils/utils';
import {styled} from "@mui/material/styles";
import {getActivityList} from "../../../redux/actions/activitiesActions";
import {useDispatch, useSelector} from "react-redux";

const PREFIX = 'TripCard';
const classes = {
    root: `${PREFIX}-root`,
    container: `${PREFIX}-container`,
    tripImage: `${PREFIX}-trip-image`,
    status: `${PREFIX}-status`,
    hold: `${PREFIX}-hold`,
    waiting: `${PREFIX}-waiting`,
    paid: `${PREFIX}-paid`,
    tripTitle: `${PREFIX}-tripTitle`,
    tripDetailsContainer: `${PREFIX}-tripDetailsContainer`,
    tripDetails: `${PREFIX}-tripDetails`,
    footerInfo: `${PREFIX}-footerInfo`,
}
const PaperTrip = styled(Paper)(({theme}) => ({
    [`&.${classes.root}`]: {
        marginTop: '20px',
    },
    [`& .${classes.status}`]: {
        color: 'white',
        padding: '5px',
        textTransform: 'uppercase',
        fontWeight: '600',
        fontSize: '1.4rem',
        letterSpacing: '1.2px',
    },
    [`& .${classes.container}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    [`& .${classes.tripImage}`]: {
        objectFit: 'cover',
        height: '100%',
    },[`& .${classes.hold}`]: {
        backgroundColor: 'lightgray',
    },
    [`& .${classes.waiting}`]: {
        backgroundColor: theme.palette.warning.main,
    },
    [`& .${classes.paid}`]: {
        backgroundColor: theme.palette.success.main,
    },
    [`& .${classes.tripTitle}`]: {
        fontSize: '2.4rem',
        letterSpacing: '1.2px'
    },
    [`& .${classes.tripDetailsContainer}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
    },
    [`& .${classes.tripDetails}`]: {
        fontSize: '1.2rem',
        marginLeft: '5px'
    },
    [`& .${classes.footerInfo}`]: {
        fontWeight: '600'
    }
}))

const FareharborBookingCard = ({booking, update}) => {
    const history = useHistory();

    const getStatus = () => {
        if (parseInt(booking['bookStateFk']) === 1) {
            if (booking.TotalPaid < booking.DealerPrice)
                return 'waiting';
            return 'paid';
        }
        if (parseInt(booking['bookStateFk']) === 2)
            return 'hold';
    };

    const getStatusText = () => {
        if (parseInt(booking['bookStateFk']) === 1) {
            if (booking.TotalPaid < booking.DealerPrice)
                return 'Awaiting Payment';
            return 'Paid';
        }
        if (parseInt(booking['bookStateFk']) === 2) {
            const bookingTime = format(parse(booking.bookDate, 'yyyy-MM-dd HH:mm:ss', new Date()), 'HH:mm:ss');
            const depositDate = parse(`${booking.DepositDate} ${bookingTime}`, 'yyyy-MM-dd HH:mm:ss', new Date());
            const difference = differenceInHours(depositDate, new Date());
            const remainingTime = difference > 0 ? `${difference} Hours left` : 'Contact our office';
            return `On Hold - ${remainingTime}`;
        }
    };

    const handleReview = () => {
        history.push(`/booking/day-trips/${booking.id}/${parseInt(booking['bookStateFk']) === 2?'hold':'confirmation'}`);
    };

    // const brandLogo = booking['upcoming_company']==='bajaex-mxn'?'https://bajaex.com/wp-content/uploads/2024/02/cropped-cropped-2022-Baja-Expeditions-Logo-White-Glow.webp':'https://seecreaturesbaja.com/wp-content/uploads/2022/08/cropped-SeeCreatures-Logos-2021-2.png';

    return (
        <PaperTrip className={classes.root} elevation={3} sx={{mx: {xs: '1.6rem', lg: '0'}}}>
            <Grid container>
                <Grid item sm={12} md={3} style={{width: '100%'}}>
                    <div className={classes.container}>
                        {booking['Calculation'] && Object.values(booking['Calculation']['activities']).length > 0 && (
                            (() => {
                                const activity = Object.values(booking['Calculation']['activities'])[0];
                                return activity ? (
                                    <img
                                        className={classes.tripImage}
                                        src={activity['activityImage']}
                                        alt={activity['activity']}
                                    />
                                ) : null;
                            })()
                        )}

                    </div>
                </Grid>
                <Grid item sm={12} md={9}>
                    <Container>
                        <div style={{margin: '0 10px'}}>
                            {update ? (<p style={{marginBottom: '10px'}}>
                                <span className={`${classes.status} ${classes[getStatus()]}`}>
                                    {getStatusText()}
                                </span>
                            </p>) : <br/>}
                            <Typography variant="h3" className={classes.tripTitle}>
                                Booking Confirmation #: {booking.Confirmation} {booking.clientbookingref?` - ${booking.clientbookingref}`:''} {booking.clientname?` - ${booking.clientname}`:''}
                            </Typography>
                            <Grid container spacing={3} style={{paddingTop: '10px'}}>
                                <Grid item className={classes.tripDetailsContainer} xs={12} sm={12} md={9}>
                                    {booking['Calculation'] && Object.values(booking['Calculation']['activities']).length>0 && Object.values(booking['Calculation']['activities']).map((activity)=>
                                        <div key={activity.id}>
                                            <Icon style={{color: lightBlue[500]}}
                                                  className={'tripInfoIcon far fa-calendar-alt'}/>
                                            <span className={classes.tripDetails}> {getDayTripFormattedDate(activity['date'])}</span>&nbsp;<strong style={{marginLeft:'10px'}}>{activity['activity']} - {activity['pax']} Guest(s)</strong>
                                            <br/>
                                        </div>
                                    ) }

                                </Grid>
                                {/*<Grid item className={classes.tripDetailsContainer} xs={12} sm={12} md={3}>*/}
                                {/*    <img src={brandLogo} alt={booking['upcoming_company']} height={35}/>*/}
                                {/*</Grid>*/}
                                <Grid item className={classes.tripDetailsContainer} xs={12} sm={12} md={3}>
                                    <PrimaryButton onClick={handleReview}>View</PrimaryButton>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </Grid>
            </Grid>
        </PaperTrip>
    );
};

export default FareharborBookingCard;